import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.757 3.328v-.69a1.417 1.417 0 0 0-1.42-1.41h-6.68a1.408 1.408 0 0 0-1.41 1.41v.68a2.694 2.694 0 0 0 .17 5.25 4.756 4.756 0 0 0 3.83 3.45v1.26h-1.92a.75.75 0 0 0 0 1.5h5.34a.75.75 0 0 0 0-1.5h-1.92v-1.26a4.755 4.755 0 0 0 3.84-3.45 2.69 2.69 0 0 0 .17-5.24ZM3.247 6.9a1.177 1.177 0 0 1 0-1.94Zm8.01.42a3.255 3.255 0 1 1-6.51 0V2.728h6.51Zm1.5-.42V4.948a1.2 1.2 0 0 1 0 1.95Z';
const draw24px =
  'M19,5.246h-.25V4.006A1.753,1.753,0,0,0,17,2.256H7a1.752,1.752,0,0,0-1.75,1.75v1.24H5A2.755,2.755,0,0,0,2.25,8v1.83A2.748,2.748,0,0,0,5,12.576h.439a6.749,6.749,0,0,0,5.811,5.13V20.3H8a.75.75,0,0,0,0,1.5h8a.75.75,0,0,0,0-1.5H12.75v-2.59a6.749,6.749,0,0,0,5.81-5.13H19a2.748,2.748,0,0,0,2.75-2.75V8A2.755,2.755,0,0,0,19,5.246ZM5.25,11.076H5a1.25,1.25,0,0,1-1.25-1.25V8A1.25,1.25,0,0,1,5,6.746h.25Zm12-.07a5.25,5.25,0,0,1-10.5,0v-7A.248.248,0,0,1,7,3.756H17a.248.248,0,0,1,.25.25Zm3-1.18A1.251,1.251,0,0,1,19,11.076h-.25V6.746H19A1.251,1.251,0,0,1,20.25,8Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TrophyIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'trophy'),
) as IconWithRender;

TrophyIcon.displayName = 'TrophyIcon';
TrophyIcon.propTypes = Icon.propTypes;
TrophyIcon.renderIcon = (props) => <TrophyIcon {...props} />;
export default TrophyIcon;
